export const WORKFLOW_BUILDER_KEY = 'workflow-builder';
export const PATHS = {
  FLOWS_LIST: '/flow',
  FLOW_BUILDER: ':flowId',
};
